"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Viewer = _interopRequireDefault(require("../Canvas/Viewer"));

var _LoadingScreen = _interopRequireDefault(require("./LoadingScreen"));

var _LoadingError = _interopRequireDefault(require("./LoadingError"));

var _FormActions = require("../../redux/Form/FormActions");

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

var _SideBar = _interopRequireDefault(require("../SideBar/SideBar"));

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof3(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Home = function Home(_ref) {
  var onLastSave = _ref.onLastSave,
      appHeight = _ref.appHeight,
      formData = _ref.formData,
      apiResponseError = _ref.apiResponseError,
      loading = _ref.loading,
      loadInForm = _ref.loadInForm,
      loadFormQuestions = _ref.loadFormQuestions;

  var _useState = (0, _react.useState)(false),
      showError = _useState[0],
      setShowError = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      loadError = _useState2[0],
      setLoadError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      firstRender = _useState3[0],
      setFirstRender = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      loadingTimeOut = _useState4[0],
      setLoadingTimeOut = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      questionsFecthed = _useState5[0],
      setQuestionsFetched = _useState5[1];

  var isEmpty = function isEmpty(arg) {
    return arg == null || arg.length === 0 || (0, _typeof2["default"])(arg) === 'object' && Object.keys(arg).length === 0;
  };

  var loadingTimeoutInterval = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (firstRender) {
      setFirstRender(false);
      loadInForm();
      loadingTimeoutInterval.current = setTimeout(function () {
        setLoadingTimeOut(true);
        setLoadError(true);
      }, 30000);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!firstRender && !questionsFecthed) {
      if (isEmpty(formData.thumbnails) && !loadingTimeOut) {
        setTimeout(function () {
          loadInForm();
        }, 1000);
      } else if (loadingTimeOut) {
        setLoadError(true);
        clearInterval(loadingTimeoutInterval.current);
      } else {
        setQuestionsFetched(true);
        clearInterval(loadingTimeoutInterval.current);
        loadFormQuestions();
      }
    }
  }, [formData]);
  (0, _react.useEffect)(function () {
    if (apiResponseError != null) {
      setShowError(true);
    }
  }, [apiResponseError]);

  var showErrorModal = function showErrorModal() {
    setShowError(false);
  };

  var containerStyle = {
    height: appHeight + "px"
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, {
      fluid: true
    }, // eslint-disable-next-line
    loading ?
    /*#__PURE__*/
    _react["default"].createElement(_LoadingScreen["default"], null) : isEmpty(formData.thumbnails) && loadError === false ?
    /*#__PURE__*/
    _react["default"].createElement(_LoadingScreen["default"], null) :
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Row, null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "col-3 bg-white pr-0 pl-0"
    },
    /*#__PURE__*/
    _react["default"].createElement(_SideBar["default"], {
      onLastSave: onLastSave,
      appHeight: appHeight
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "col-9 bg-light scroller overflow-auto container-fluid text-center",
      style: containerStyle
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal, {
      show: showError,
      onHide: function onHide() {
        return setShowError(false);
      },
      className: "modal",
      centered: true
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Header, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Title, null, "Error")),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Body, null, "Unable to save last change. Form will be returned to the last save."),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Modal.Footer, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: "primary",
      onClick: showErrorModal,
      "data-cy": "delete-modal-button"
    }, "Ok"))), formData.thumbnails && loadError === false ?
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, Object.keys(formData.thumbnails).map(function (key, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_Viewer["default"], {
          key: key,
          pageNumber: i + 1,
          img: formData.thumbnails[key]
        })
      );
    })) :
    /*#__PURE__*/
    _react["default"].createElement(_LoadingError["default"], null))))
  );
};

Home.defaultProps = {
  appHeight: window.innerHeight,
  apiResponseError: null,
  formData: {},
  loading: true
};
Home.propTypes = process.env.NODE_ENV !== "production" ? {
  onLastSave: _propTypes["default"].func.isRequired,
  appHeight: _propTypes["default"].number,
  apiResponseError: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  formData: _propTypes["default"].objectOf(_propTypes["default"].any),
  loading: _propTypes["default"].bool,
  loadInForm: _propTypes["default"].func.isRequired,
  loadFormQuestions: _propTypes["default"].func.isRequired
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    apiResponseError: state.questionSet.error,
    formData: state.form.document,
    loading: state.form.loading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadInForm: function loadInForm() {
      return dispatch((0, _FormActions.loadForm)(window.pdfFormConfigObject.form_thumbnail_url));
    },
    loadFormQuestions: function loadFormQuestions() {
      return dispatch((0, _QuestionsActions.loadQuestions)(window.pdfFormConfigObject.form_questions_url));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);